import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonView } from './button_view';
import { ActivityNameIcon } from './activity_icon.component';
export const ActivityNamesPreview = ({ productMessages, messages }) => {
    if (!messages) {
        return null;
    }
    return [
        _jsx("div", { "data-study-product-version": 'r440', style: {
                backgroundColor: '#f5f4f9',
                padding: '1rem',
                height: '100%',
                borderRadius: '1rem',
            }, children: _jsx("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '1rem',
                    height: '100%',
                    maxWidth: '976px',
                    margin: '0 auto',
                    width: '100%',
                }, children: Object.values(messages).map((value) => {
                    var _a;
                    return (_jsxs("div", { style: {
                            border: '1px solid rgb(209, 213, 219)',
                            padding: '2em',
                            color: 'rgb(17, 24, 39)',
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            fontSize: '16px',
                            fontWeight: '600',
                            lineHeight: '24px',
                        }, children: [_jsxs("div", { style: {
                                    position: 'relative',
                                    paddingInlineStart: 35,
                                    marginBottom: 15,
                                    wordBreak: 'normal',
                                    overflowWrap: 'anywhere',
                                }, children: [_jsx("div", { style: { width: 24, height: 24, position: 'absolute', insetInlineStart: 0, top: 0 }, children: _jsx(ActivityNameIcon, {}) }), value] }), _jsx(ButtonView, { label: (_a = productMessages === null || productMessages === void 0 ? void 0 : productMessages.button) !== null && _a !== void 0 ? _a : 'Start activity', customStyles: { height: 40 } })] }, value));
                }) }) }, 'activity-names-root'),
    ];
};
//# sourceMappingURL=activity_names.preview.component.js.map